// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"1a07c896","833":"e8f3622a"}[chunkId] + ".chunk.js";
};